import axios from 'axios';

function baseUrl() {
  const port = window.location.port === '' ? '' : `:${window.location.port}`;

  return `${window.location.protocol}//${window.location.hostname}${port}`;
}

export function csrfToken() {
  return document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');
}

export default function createNetworkingClient(options = {}) {
  return axios.create({
    baseUrl: baseUrl(),
    timeout: 5000,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': csrfToken()
    },
    ...options
  });
}
